// extracted by mini-css-extract-plugin
export default {"deleteTitle":"DeleteReview_deleteTitle__B8JY3","container":"DeleteReview_container__N237j"};